// extracted by mini-css-extract-plugin
module.exports = {"itemOpened":"MenuItem_item-opened__U1hO8","icon":"MenuItem_icon__Fx4RX","wrap":"MenuItem_wrap__cCGFJ","link":"MenuItem_link__wP1EQ","active":"MenuItem_active__1VVSR"};